import React from "react";
import { Form, Input } from "antd";
import styles from "./antdInput.module.css";

const AntdInput = ({
  name,
  label,
  rules,
  placeholder,
  className,
  value,
  onChange,
  maxLength,
  style,
  disabled,
  ref,
}) => {
  return (
    <>
      <Form.Item
        labelCol={{ span: 24 }}
        wrapperCol={{ span: 24 }}
        style={style}
        className={className}
        name={name}
        label={
          label ? <label className={styles.label_style}>{label}</label> : null
        }
        rules={rules}
      >
        <Input
        
          ref={ref}
          disabled={disabled}
          maxLength={maxLength}
          onChange={onChange}
          value={value}
          className={styles.input}
          style={{ border: "2px solid white", backgroundColor: "transparent" }}
          placeholder={placeholder}
        />
      </Form.Item>
    </>
  );
};

export default AntdInput;
